import React from 'react';
import { motion } from 'framer-motion';
import { FaStar } from 'react-icons/fa';

const Testimonials = ({ onContactClick }) => {
  const testimonials = [
    {
      name: "Client Review",
      location: "Washington State",
      rating: 5,
      text: "Sky Harbor Shuttle has been providing excellent transportation services. The drivers are professional, courteous, and always on time. Highly recommended!",
      service: "Medical Transportation"
    },
    {
      name: "Client Review",
      location: "Grays Harbor County",
      rating: 5,
      text: "Reliable service for my regular dialysis appointments. The team understands the importance of being on time and provides compassionate care throughout the journey.",
      service: "Dialysis Transportation"
    },
    {
      name: "Client Review",
      location: "Western Washington",
      rating: 5,
      text: "Professional, safe, and caring transportation service. They made my hospital discharge and follow-up appointments stress-free. Thank you for your excellent service!",
      service: "Hospital Discharge"
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <motion.div
          className="testimonials-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>What Our Clients Say</h2>
          <p>We're proud to serve the Washington State community with reliable, compassionate transportation services.</p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              className="testimonial-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.02, 
                boxShadow: "0 10px 20px rgba(0,0,0,0.1)" 
              }}
            >
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="star-icon" />
                ))}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-meta">
                <div className="testimonial-name">{testimonial.name}</div>
                <div className="testimonial-location">{testimonial.location}</div>
                <div className="testimonial-service">{testimonial.service}</div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="testimonials-cta"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p>Have you used our services? We'd love to hear from you!</p>
          <button onClick={(e) => onContactClick && onContactClick(e)} className="cta-link">Share Your Experience</button>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;

